import React from 'react';
import { useInstantSearch, useStats } from 'react-instantsearch';

const SeeAllResults = (props) => {
    const { nbHits } = useStats();
    const { indexUiState } = useInstantSearch();

    if (nbHits < 3) return null;

    const encodedSearchState = encodeURIComponent(indexUiState.query);
    const handleClick = () => {
        window.location = `/search?keywords=${encodedSearchState}`;
    };

    return (
        <>
            {indexUiState.query && (
                <button
                    onClick={() => handleClick()}
                    className="button -outline -dark"
                    style={{ marginBottom: '45px', marginTop: '20px' }}
                >
                    See All {nbHits} Results
                </button>
            )}
        </>
    );
};

export default SeeAllResults;
